import { padStart } from 'lodash';
import moment from 'moment';

export const getDuration = (record: { from: string; till?: string }): string | null => {
  if (record.till && moment(record.till).isAfter(moment())) {
    const countdownSeconds = moment(record.till).diff(moment(), 'seconds');
    const d = Math.floor(countdownSeconds / 60 / 60 / 24);
    const h = Math.floor((countdownSeconds - d * 60 * 60 * 24) / 60 / 60);
    const m = Math.floor((countdownSeconds - d * 60 * 60 * 24 - h * 60 * 60) / 60);
    const s = Math.floor(countdownSeconds - d * 60 * 60 * 24 - h * 60 * 60 - m * 60);

    return ([] as string[])
      .concat([d ? `${toTime(d)} days` : ''])
      .concat([d || h ? `${toTime(h)} hours` : ''])
      .concat([d || h || m ? `${toTime(m)} minutes` : ''])
      .concat([d || h || m || s ? `${toTime(s)} seconds` : ''])
      .filter(Boolean)
      .join(', ');
  }
  return null;
};

const toTime = (num: number) => {
  return padStart(`${num}`, 2, '0');
};
